<template>
  <div class="info-menu">
    <vue-client-only>
      <accordion
        :items="items"
        :extendable="adaptive.isMobile"
        @item-click="onClick"
      >
        <template
          #title="{ data }"
        >
          <info-title-params
            v-if="data.rating || data.counter"
            :rating="data.rating"
            :counter="data.counter"
          />
        </template>

        <template #default="{ data }">
          <components :is="getComponent(data.key)" />
        </template>
      </accordion>
    </vue-client-only>
  </div>
</template>

<script>
import VueClientOnly from 'vue-client-only';
import { mapGetters } from 'vuex';
import InfoTitleParams from './info-title-params.vue';
import {
  DELIVERY_INFO_DATA,
  DESCRIPTION_INFO_DATA,
  REVIEW_INFO_DATA,
} from '@/components/product/info-blocks/info-blocks-config';
import Accordion from '@/components/product/info-menu/accordion';
import productInfoBlocksMixin from '@/mixins/product-info-blocks';
import { productGtmEvents } from '@/gtm/product';


export default {
  name: 'info-menu',

  components: {
    InfoTitleParams,
    Accordion,
    VueClientOnly,
  },

  mixins: [productInfoBlocksMixin],

  inject: ['adaptive'],

  props: {
    productCode: {
      type: String,
      default: '',
    },
    cityName: {
      type: String,
      default: '',
    },
    activeSku: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      REVIEWS_COUNT: 'product/reviewsСount',
    }),

    items() {
      return this.availableItems.map(({
        key,
        name,
        ratingGetter,
        counterGetter,
      }) => ({
        key,
        title: name,
        rating: this.$store.getters[ratingGetter],
        counter: this.$store.getters[counterGetter],
      }));
    },
  },

  methods: {
    onClick(key) {
      if (key === DESCRIPTION_INFO_DATA.key && this.productCode) {
        productGtmEvents.card.clickDescriptionTab({ productCode: this.productCode });
      }

      if (key === REVIEW_INFO_DATA.key && this.productCode) {
        productGtmEvents.reviews.clickTab({
          productCode: this.productCode,
          reviewsCount: this.REVIEWS_COUNT,
        });
      }

      if (key === DELIVERY_INFO_DATA.key && this.productCode) {
        productGtmEvents.card.clickDeliveryTab({
          productCode: this.productCode,
          cityName: this.cityName,
          activeSku: this.activeSku,
        });
      }

      // переключаем таб для десктопа
      if (this.adaptive.isMobile) return;

      // если уже на этом хэше - то сбрасываем, нужно для избежания ошибки и работы анимации скролла
      this.$router.push({ hash: '', query: this.$route.query });
      this.$nextTick(function () {
        this.$router.push({ hash: key, query: this.$route.query });
      });
    }
  }
}
</script>

<style lang="scss">
  .info-menu {
    .ui-accordion-content {
      margin-left: -12px;
      margin-right: -12px;
    }
  }
</style>
